export const fundingRequestRoutes = [
  {
    path: "/fundingrequest/create",
    component: () => import("@/views/FundingRequest/Create.vue"),
  },

  {
    path: "/fundingrequest/update/:reference",
    component: () => import("@/views/FundingRequest/Create.vue"),
  },
  {
    path: "/fundingrequest/review/:reference",
    component: () => import("@/views/FundingRequest/Review.vue"),
  },
  {
    path: "/fundingrequest/view/:reference",
    component: () => import("@/views/FundingRequest/AdminApprove.vue"),
  },

  {
    path: "/fundingrequest/list",
    component: () => import("@/views/FundingRequest/ListSchoolOfficer.vue"),
  },

  {
    path: "/fundingrequest",
    component: () => import("@/views/FundingRequest/List.vue"),
  },
];
